module.exports = __webpack_public_path__ + "media/application/images/svgs/twitter-contact-865b86b2fd0acdc0c5965e427f2b1a58.svg";